import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, withRouter } from 'react-router-dom';

import { OVERVIEW_MENU, WEB_MENU, IOS_MENU, ANDROID_MENU } from '../components/core/MenuComponent/MenuConstants';
import DeveloperApiComponent from '../components/developerApi/DeveloperApiComponent';

const menuItemsByApi = {
    'overview': {
        ...OVERVIEW_MENU,
    },
    'web': {
        ...WEB_MENU,
    },
    'ios': {
        ...IOS_MENU,
    },
    'android': {
        ...ANDROID_MENU,
    },
};

const apis = Object.keys(menuItemsByApi);

class DeveloperApiRoute extends React.Component {
    render() {
        const api = this.props.match.params.api;
        const fixedApi = apis.indexOf(api) > -1 ? api : apis[0];
        const pathParts = this.props.location.pathname.split('/');
        const menuItem = menuItemsByApi[fixedApi][pathParts[3]];
        const subMenuItemName = pathParts[4];

        if (api === fixedApi && fixedApi === 'overview' && pathParts[3] === 'started') {
            return <DeveloperApiComponent tab={api} />
        }

        return api === fixedApi && menuItem && (!subMenuItemName || menuItem.subMenu[subMenuItemName])
            ? <DeveloperApiComponent tab={api} />
            : <Redirect to={`/api/${fixedApi}/started`} />;
    }
}

DeveloperApiRoute.propTypes = {
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
};

export default withRouter(DeveloperApiRoute);



// WEBPACK FOOTER //
// ./src/routes/DeveloperApiRoute.js